import React, { useState, useEffect, Fragment } from 'react';
import ReactTable from 'react-table';
import Breadcrumb from '../common/breadcrumb';
import Loader from '../common/loader';
import api from '../../config/axios';
import { useStateValue } from '../../store';
import ReviewItem from './common/item';

const columnsDataTable = (count, role) => [
    {
        Cell: (row) => <ReviewItem data={row.original} />,
        style: {
            textAlign: 'center',
            width: '100%',
        },
        sortable: false,
        width: '100%',
    },
];

function ReviewsUsuario(props) {
    const [{ auth }] = useStateValue();
    const [news, setNews] = useState({
        list: [],
        loaded: false,
        pagination: {
            page: 1,
        },
    });
    useEffect(() => {
        fetchReviews(news.pagination.page);
    }, []);

    const fetchReviews = async () => {
        const { data } = await api.get(`/user/${auth.user.id}/reviews?limit=100`);
        const reviews = parseToDatatable(data.data);

        setNews({
            loaded: true,
            list: reviews,
        });
    };

    const parseToDatatable = (array) => {
        return array;
    };

    const handlePage = (page) => {
        fetchReviews();
    };

    if (!news.loaded)
        return (
            <div style={{ display: 'flex', height: '50vh' }}>
                <Loader />
            </div>
        );

    const columns = columnsDataTable();
    return (
        <Fragment>
            <Breadcrumb title="⭐ Calificaciones" />
            {/* <!-- Container-fluid starts--> */}
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="clearfix"></div>
                                <div className="table-boxes">
                                    <ReactTable
                                        columns={columns}
                                        className="-striped -highlight"
                                        multiSelectOption={false}
                                        data={news.list}
                                        page={1}
                                        defaultPageSize={columnsDataTable.length}
                                        showPageSizeOptions={false}
                                        onPageChange={(index) => handlePage(index + 1)}
                                        manual
                                        nextText="Siguiente"
                                        previousText="Anterior"
                                        getTrProps={(state, rowInfo, column, instance) => ({
                                            onClick: (e) =>
                                                props.history.push(
                                                    `/recargas/detalle/${rowInfo.original.purchase.id}`,
                                                ),
                                        })}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default ReviewsUsuario;
